import { PagedRequestDto } from '@umss/shared/data-access';
import { AdminNotificationType } from '../../enums';

export interface NotificationHistorySearchDto extends PagedRequestDto {
  sentByUserId?: string | null; // Guid
  notificationType?: AdminNotificationType | null;
  sentDateFrom?: string | null; // DateTime as ISO string
  sentDateTo?: string | null; // DateTime as ISO string
  isUrgent?: boolean | null;
}
